import React, { Children, cloneElement } from "react";
import classNames from "classnames";

import { Grid, Cell } from "../grid/Grid.jsx";
import "./styles.styl";

export default function Fieldset(props) {
  const { className, children, ...rest } = props;

  return (
    <Grid className={classNames("fieldset", className)} {...rest}>
      {Children.map(children, (child, i) => {
        if (!child) return;

        let { size, sizeS, sizeM, sizeL, ...rest } = child.props;

        if (!size) size = "auto";

        return (
          <Cell key={i} size={size} sizeS={sizeS} sizeM={sizeM} sizeL={sizeL}>
            <child.type {...rest} />
          </Cell>
        );
      })}
    </Grid>
  );
}
